var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86077 0.388408C9.02362 -0.12947 7.97638 -0.129469 7.13922 0.388409L6.5339 0.762871C5.06517 1.67145 3.41631 2.22899 1.70942 2.3942L1.32805 2.43111C0.575258 2.50398 0 3.15326 0 3.93007V5.91009C0 9.25687 1.32258 12.4602 3.66477 14.7864L7.48141 18.5769C8.04945 19.141 8.95055 19.141 9.51859 18.5769L13.3352 14.7864C15.6774 12.4602 17 9.25686 17 5.91008V3.93007C17 3.15326 16.4247 2.50398 15.6719 2.43111L15.2906 2.3942C13.5837 2.22899 11.9348 1.67145 10.4661 0.76287L9.86077 0.388408Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86077 0.388408C9.02362 -0.12947 7.97638 -0.129469 7.13922 0.388409L6.5339 0.762871C5.06517 1.67145 3.41631 2.22899 1.70942 2.3942L1.32805 2.43111C0.575258 2.50398 0 3.15326 0 3.93007V5.91009C0 9.25687 1.32258 12.4602 3.66477 14.7864L7.48141 18.5769C8.04945 19.141 8.95055 19.141 9.51859 18.5769L13.3352 14.7864C15.6774 12.4602 17 9.25686 17 5.91008V3.93007C17 3.15326 16.4247 2.50398 15.6719 2.43111L15.2906 2.3942C13.5837 2.22899 11.9348 1.67145 10.4661 0.76287L9.86077 0.388408Z",
    fill: "url(#paint0_linear_4_518)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_518",
    x1: 8.4787,
    y1: 2.19624,
    x2: 8.47869,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/iconSecure.7d49ed71eeab2bcd528d916ebfbd05aa.svg";
export { ForwardRef as ReactComponent };